export default "__VITE_ASSET__f3c216d1__"